import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { validateSocialChannel, removeSocialChannel } from "actions/signup";
import { validateSocialChannel as validateSocialChannelHome } from "actions/home";
import YouTube from "components/Icons/YoutubeFlat";
import Instagram from "components/Icons/InstagramFlat";
import TikTok from "components/Icons/TikTokFlat";
import ActionSpinner from "components/ActionSpinner";
import CheckmarkIcon from "components/Icons/Checkmark";

const ChannelInput = ({
  platform = "Platform name",
  channel,
  isReviewPage = false,
  isMyAccountPage = false,
}) => {
  const dispatch = useDispatch();
  const [isValidated, setIsValidated] = useState(false);
  const [channelURL, setChannelURL] = useState("");
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validator = isMyAccountPage
    ? validateSocialChannelHome
    : validateSocialChannel;

  useEffect(() => {
    if (channel?.username) {
      setChannelURL(channel?.username);
      setIsValidated(true);
    }
  }, [channel]);

  const validateChannel = (URL) => {
    if (!URL) return;
    // Call API to validate channel
    setIsSubmitting(true);
    try {
      dispatch(
        validator(
          {
            social_channel: platform?.toLowerCase(),
            url: URL.trim(),
            channel_id: channel?.id,
          },
          (validationResponse) => {
            setIsSubmitting(false);
            if (validationResponse?.success) {
              setHasError(false);
              setErrorMessage("");
              setIsValidated(true);
            } else {
              setHasError(true);
              // setErrorMessage(validationResponse?.error);
              setErrorMessage("Invalid URL or @username");
            }
          }
        )
      );
    } catch (error) {
      setIsSubmitting(false);
    }
  };

  const onRemoveChannel = () => {
    setIsSubmitting(true);

    if (!isMyAccountPage) {
      try {
        dispatch(
          removeSocialChannel(
            {
              social_channel: platform,
            },
            () => {
              setChannelURL("");
              setIsValidated(false);
              setIsSubmitting(false);
            }
          )
        );
      } catch (error) {
        setIsSubmitting(false);
      }
    } else {
      setChannelURL("");
      setIsValidated(false);
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <label className="text-sm text-primary-700 font-medium">{platform}</label>
      <div
        className={`w-full flex items-center justify-between border p-2 text-sm bg-white rounded group ${
          hasError
            ? "border-system-red focus-within:ring-0"
            : "focus-within:ring-1 focus-within:ring-black border-light-border"
        }`}
      >
        <span className="inline-flex justify-center items-center lg:w-10 lg:h-10 lg:p-1 lg:border lg:border-light-border lg:rounded text-primary-900">
          {platform === "YouTube" && <YouTube />}
          {platform === "Instagram" && <Instagram className="w-6 h-6" />}
          {platform === "TikTok" && <TikTok />}
        </span>
        <input
          type="text"
          value={channelURL}
          onChange={(e) => {
            const value = e?.target?.value;
            setChannelURL(value);
            if (!value && hasError) {
              setHasError(false);
              setErrorMessage("");
            }
          }}
          className={`text-primary-900 placeholder:text-primary-600 appearance-none border-0 text-xs focus:outline-0 focus:ring-0 flex-grow px-1 lg:px-2 ${
            isValidated || isSubmitting ? "cursor-default" : "cursor-text"
          }`}
          readOnly={isValidated || isSubmitting}
          placeholder="Profile URL, User ID, or @handle"
          autoComplete="off"
        />
        <span className="h-full inline-flex items-center">
          {!isReviewPage && (
            <button
              type="button"
              onClick={() => {
                if (isValidated) {
                  onRemoveChannel();
                } else {
                  validateChannel(channelURL);
                }
              }}
              className={`inline-flex items-center px-2 py-2 h-full text-xs lg:text-sm  bg-light-surface border border-solid border-light-border rounded ${
                !channelURL
                  ? "text-primary-600 opacity-70"
                  : !isValidated
                    ? "hover:bg-light-primary hover:text-white text-light-paragraph"
                    : "text-system-red hover:bg-system-red hover:text-white"
              } ${!channelURL && "cursor-default"}`}
              disabled={!channelURL}
            >
              {isSubmitting && (
                <ActionSpinner className="w-4 h-4 mr-2 text-primary-400 fill-primary-900" />
              )}
              {!isValidated ? "Validate" : "Clear"}
            </button>
          )}
          {isValidated && (
            <span className="w-5 h-5 inline-flex items-center justify-center p-px bg-light-primary rounded-full ml-2">
              <CheckmarkIcon className="w-5 h-5 text-white" />
            </span>
          )}
        </span>
      </div>
      {hasError && (
        <div className="text-xs text-red-500 mt-1">{errorMessage}</div>
      )}
    </div>
  );
};

export default ChannelInput;
